var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
              `w-full h-[45px] flex items-center justify-center rounded-[30px] font-bold`,
              _vm.ghost ? `bg-none border border-px border-${_vm.color} text-${_vm.color}` : `bg-${_vm.color} text-white`,
              _vm.disabled ? `pointer-events-none opacity-50` : 'cursor-pointer',
              _vm.size=='large' ? `px-[50px] py-[20px]` : _vm.size=='medium' ? `px-4` : ''
            ],on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }